// client/src/components/admin/project/ProjectCompletionValidationModal.js
import React from 'react';

export default function ProjectCompletionValidationModal({ open, onClose, validation }) {
  if (!open || !validation) return null;

  const { resultStatus, cpsStatus } = validation;

  return (
    <div className="project-completion-validation-modal">
      <div className="project-completion-validation-modal__content" onClick={(e) => e.stopPropagation()}>
        {/* 헤더 */}
        <div className="project-completion-validation-modal__header">
          <h2 className="project-completion-validation-modal__title">
            ⚠️ 프로젝트 완료 처리 불가
          </h2>
          <button onClick={onClose} className="project-completion-validation-modal__close">✕</button>
        </div>

        {/* 내용 */}
        <div className="project-completion-validation-modal__body">
          {/* 결과물 상태 오류 */}
          {!resultStatus?.valid && (
            <div className="project-completion-validation-modal__error-section">
              <div className="project-completion-validation-modal__error-title">
                ❌ {resultStatus.message}
              </div>
              {resultStatus.details && (
                <div className="project-completion-validation-modal__error-details">
                  <div className="project-completion-validation-modal__details-title">
                    상세 내역:
                  </div>
                  <ul className="project-completion-validation-modal__details-list">
                    <li>전체 계약 인원: {resultStatus.details.total}명</li>
                    {resultStatus.details.approved > 0 && (
                      <li>광고주 승인: {resultStatus.details.approved}명</li>
                    )}
                    {resultStatus.details.admin_approved > 0 && (
                      <li>관리자 최종 승인: {resultStatus.details.admin_approved}명</li>
                    )}
                    {resultStatus.details.admin_rejected > 0 && (
                      <li>관리자 계약 취소: {resultStatus.details.admin_rejected}명</li>
                    )}
                    {resultStatus.details.other > 0 && (
                      <li className="project-completion-validation-modal__invalid-item">
                        미완료 상태: {resultStatus.details.other}명
                      </li>
                    )}
                  </ul>
                  {resultStatus.invalidStatuses && resultStatus.invalidStatuses.length > 0 && (
                    <div className="project-completion-validation-modal__invalid-statuses">
                      미완료 상태 목록: {resultStatus.invalidStatuses.join(', ')}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* CPS 결산 상태 오류 */}
          {!cpsStatus?.valid && (
            <div className="project-completion-validation-modal__error-section">
              <div className="project-completion-validation-modal__error-title">
                ❌ {cpsStatus.message}
              </div>
              {cpsStatus.details && (
                <div className="project-completion-validation-modal__error-details">
                  {cpsStatus.details.pendingSettlements > 0 && (
                    <>
                      <div className="project-completion-validation-modal__cps-label">
                        미결산 회차: {cpsStatus.details.pendingSettlements}건
                      </div>
                      <div className="project-completion-validation-modal__cps-rounds">
                        회차: {cpsStatus.details.pendingSettlementRounds?.join(', ')}
                      </div>
                    </>
                  )}
                  {cpsStatus.details.pendingReservations > 0 && (
                    <>
                      <div className="project-completion-validation-modal__cps-label">
                        승인 대기 중인 자동 결산: {cpsStatus.details.pendingReservations}건
                      </div>
                      <div className="project-completion-validation-modal__cps-rounds">
                        회차: {cpsStatus.details.pendingReservationRounds?.join(', ')}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          )}

          <div className="project-completion-validation-modal__notice">
            💡 위 항목들을 먼저 처리한 후 완료 처리를 진행해주세요.
          </div>
        </div>

        {/* 푸터 */}
        <div className="project-completion-validation-modal__footer">
          <button onClick={onClose} className="project-completion-validation-modal__confirm-btn">
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

